import gql from 'graphql-tag';

const createNewEnrollmentMutation = gql`
  mutation newSubscription($newEnrollmentInput: NewSubscriptionMutationInput!) {
    newSubscription(input: $newEnrollmentInput) {
      success
      errors
    }
  }
`;

export default createNewEnrollmentMutation;
